import { ReactNode } from 'react'
import { Brand } from './Brand'

// Generic centered message screen used for mic-permission prompts, the
// silent-play decline path, the end-of-slice "complete" state, and errors.
export const StatusScreen = ({
  title,
  body,
  emoji,
  action,
}: {
  title: string
  body: ReactNode
  emoji?: string
  action?: { label: string; onClick: () => void }
}) => (
  <div className="min-h-screen flex flex-col items-center justify-center px-6 text-center">
    <Brand />
    <div className="mt-10 max-w-sm">
      {emoji && <div className="text-5xl mb-4">{emoji}</div>}
      <h2 className="text-lg font-semibold text-gray-800">{title}</h2>
      <p className="mt-2 text-gray-600 leading-relaxed">{body}</p>
      {action && (
        <button
          type="button"
          onClick={action.onClick}
          className="mt-6 rounded-lg bg-[#820458] px-6 py-3 text-white font-semibold"
        >
          {action.label}
        </button>
      )}
    </div>
  </div>
)
